//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/SelectBody.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"IsHighLightFacesWithSameClearance",1,0],[0,"PlateClearanceEighth",1,0],[0,"PlateClearanceFifth",1,0],[0,"PlateClearanceFirst",1,0],[0,"PlateClearanceFourth",1,0],[0,"PlateClearanceNinth",1,0],[0,"PlateClearanceSecond",1,0],[0,"PlateClearanceSeventh",1,0],[0,"PlateClearanceSixth",1,0],[0,"PlateClearanceTenth",1,0],[0,"PlateClearanceThird",1,0],[1,"SelectFace",0,"ScCollector",0],[1,"SelectPart",0,"SelectBody",0],[0,"ShowPartAndClearanceHoleOnly",1,0],[0,"SpecifyClearanceDataFile",1,0],[0,"ToolPartOrTargetPart",1,0],[0,"TypeAssignOrCheck",1,0],[0,"UsePlateClearanceEighth",1,0],[0,"UsePlateClearanceFifth",1,0],[0,"UsePlateClearanceFirst",1,0],[0,"UsePlateClearanceFourth",1,0],[0,"UsePlateClearanceNinth",1,0],[0,"UsePlateClearanceSecond",1,0],[0,"UsePlateClearanceSeventh",1,0],[0,"UsePlateClearanceSixth",1,0],[0,"UsePlateClearanceTenth",1,0],[0,"UsePlateClearanceThird",1,0]],[[["paraNames","paraValues"],"SetParameters",{},2,0]],[]];
SPLM.Tooling.ClearanceManagementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ClearanceManagementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ClearanceManagementBuilder.Type = Object.freeze({
    "AssignClearances" : "AssignClearances", "CheckClearances" : "CheckClearances"});

SPLM.Tooling.ClearanceManagementBuilder.Selection = Object.freeze({
    "ToolPart" : "ToolPart", "TargetPart" : "TargetPart"});

export default SPLM;